<template>
    <div class="thanks-message tw-flex tw-flex-col tw-items-center tw-content-center tw-text-center tw-h-full">
        <h1>Muito obrigado.</h1>
        <p>em breve será contactada, para uma breve explicação sobre a forma como vai participar neste grande estudo de consumos em Portugal.<br><br>
        <span>A Equipa Kantar</span></p>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    background-color: red;

    @screen md {
        max-width: 460px;
    }
}

</style>
